export default __webpack_public_path__ + "static/media/Banner.5578ca2e.svg";